export default {"src":"/_next/static/media/arrow-right-outline.1cb30821.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};